module.exports = __webpack_public_path__ + "img/fondo-full-amaro.39ac0d8c.jpg";